import api from './apiConfig';

export interface NotificationItem {
    id: string;
    // ADICIONE 'success' E 'early_success' NESTA LINHA ABAIXO:
    type: 'sale' | 'goal' | 'client' | 'product' | 'alert' | 'success' | 'early_success' | 'qc_autorizado';
    title: string;
    description: string;
    time: string;
    read: boolean;
    metadata?: any;
    orderId?: string;
}

/**
 * Busca notificações do usuário
 */
export const fetchNotifications = () => {
    return api.get<NotificationItem[]>('/notifications');
};